import {HttpContextToken} from '@angular/common/http';

/**
 * Use for requests whose duplicate-name response is rendered as an inline
 * validation error by the submitting form.
 */
export const SUPPRESS_DUPLICATE_NAME_NOTIFICATION = new HttpContextToken<boolean>(() => false);
